import React, { Component } from "react";
import { MPaper } from "../../../../UI";
import classes from "./SquareCard.module.css";
class SquareCard extends Component {
  state = {
    hoverToggle: false
  };
  mouseEnterHandler = () => {
    this.setState({ hoverToggle: true });
  };
  mouseLeaveHandler = () => {
    this.setState({ hoverToggle: false });
  };
  render() {
    return (
      <>
        <MPaper
          elevation={this.state.hoverToggle ? 8 : 1}
          onMouseEnter={this.mouseEnterHandler}
          onMouseLeave={this.mouseLeaveHandler}
          {...this.props}
          className={classes.Card}
        >
          {this.props.children}
        </MPaper>
      </>
    );
  }
}

export default SquareCard;
